import React from "react";
import "./ExclusiveLuxury.css";
import phoneScreen1 from "../assets/images/phone-screen-1.png";
import phoneScreen2 from "../assets/images/phone-screen-2.png";

const ExclusiveLuxury = () => {
  return (
    <section className="exclusive-luxury section exclusive-luxury-section">
      <div className="exclusive-luxury-container">
        <div className="exclusive-luxury-background">
          <div className="background-ellipse"></div>
        </div>

        <div className="exclusive-luxury-content">
          <div className="content-text">
            <h2 className="section-title">
              <span className="black-color">Cop Exclusive</span> <br />
              <span className="lux-with">Luxury with</span> <br />
              <span className="flow">Flow</span>
            </h2>
            <p className="section-title-subtitle">
              Explore a curated marketplace of unique items available for
              auction. Join live streams to bid in real-time and secure
              exclusive collectibles, products, and services. Powered by $Flow
              our platform brings together a community of collectors and
              creators with exclusive access to unique items.
            </p>
          </div>

          <div className="content-phones">
            <div className="phone-mockup mt-150px">
              <div className="phone-frame">
                <img
                  src={phoneScreen1}
                  alt="Live Stream Interface"
                  className="phone-screen"
                />
              </div>
            </div>
            <div className="phone-mockup">
              <div className="phone-frame">
                <img
                  src={phoneScreen2}
                  alt="Auction Interface"
                  className="phone-screen"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExclusiveLuxury;
